import { Injectable, TemplateRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NzNotificationService, NzNotificationDataOptions } from 'ng-zorro-antd/notification';

import { Z_INDEX_NOTIFICATION_CONTAINER } from '@rappider/shared/definitions';

const DEFAULT_NOTIFICATION_PLACEMENT = 'bottomRight';
const DEFAULT_NOTIFICATION_DURATION = 6000;
const DEFAULT_NOTIFICATION_MAX_STACK = 7;


@Injectable({
  providedIn: 'root'
})
export class NotificationService {


  constructor(
    private nzNotificationService: NzNotificationService,
    private translateService: TranslateService
  ) { }

  createNotification(type: string, title: string, content: string, options: NzNotificationDataOptions = {}) {
    this.nzNotificationService[type](
      this.translateService.instant(title),
      this.translateService.instant(content),
      {
        nzPlacement: DEFAULT_NOTIFICATION_PLACEMENT,
        nzDuration: DEFAULT_NOTIFICATION_DURATION,
        nzMaxStack: DEFAULT_NOTIFICATION_MAX_STACK,
        nzPauseOnHover: true,
        ...options
      }
    );

    setTimeout(() => {
      const notificationEl = document.querySelector('.ant-notification');
      if (notificationEl) {
        const grandparent = notificationEl.parentElement?.parentElement?.parentElement;
        const grandGrandParent = notificationEl.parentElement?.parentElement?.parentElement;
        if (grandparent) {
          grandparent.style.zIndex = Z_INDEX_NOTIFICATION_CONTAINER;
        }
        if (grandGrandParent) {
          grandGrandParent.style.zIndex = Z_INDEX_NOTIFICATION_CONTAINER;
        }
      }
    }, 100);
  }

  createNotificationTemplate(template: TemplateRef<{}>, options: NzNotificationDataOptions = {}) {
    this.nzNotificationService.template(template, {
      nzDuration: DEFAULT_NOTIFICATION_DURATION,
      nzPauseOnHover: true,
      nzPlacement: DEFAULT_NOTIFICATION_PLACEMENT,
      nzClass: 'rappider-notification',
      ...options
    });
  }

  /**
   * remove all notifications
   *
   * @memberof NotificationService
   */
  removeAllNotifications() {
    this.nzNotificationService.remove();
  }

  /**
   * Remove the notification with the specified id
   *
   * @memberof NotificationService
   */
  removeNotification(id: string) {
    this.nzNotificationService.remove(id);
  }

}
